import { Action } from 'redux';
import { AssoMediaEvent, Playlist } from '../entities';

export enum TWishlist {
  LIKE = 'LIKE',
  DISLIKE = 'DISLIKE',
  SET_WISHLIST = 'SET_WISHLIST',
  FETCH_WISHLIST = 'FETCH_WISHLIST',
}

export interface ILike extends Action {
  type: TWishlist.LIKE;
  payload: AssoMediaEvent;
}
export const ALike = (payload: AssoMediaEvent): ILike => ({ type: TWishlist.LIKE, payload });

export interface IDislike extends Action {
  type: TWishlist.DISLIKE;
  payload: string;
}
export const ADislike = (payload: string): IDislike => ({ type: TWishlist.DISLIKE, payload });

export interface ISetWishlist extends Action {
  type: TWishlist.SET_WISHLIST;
  payload: Playlist;
}
export const ASetWishlist = (payload: Playlist): ISetWishlist => ({ type: TWishlist.SET_WISHLIST, payload });

export interface IFetchWishlist extends Action {
  type: TWishlist.FETCH_WISHLIST;
}
export const AFetchWishlist = (): IFetchWishlist => ({ type: TWishlist.FETCH_WISHLIST });
